import React, { useState, useEffect, useContext } from "react";
import { SendBirdProvider } from "sendbird-uikit";
import ChatContext, { defaultChatState } from "../../../context/ChatContext";
import { useQuery } from "@apollo/react-hooks";
import { GetSendbirdInfo } from "./queries";
import { Belt } from "../../../layouts/Belt";
import { Spinner } from "@blueprintjs/core";
import useAuthState from "../../../hooks/useAuthState";

export default function Chat({ children }) {
  const [chatInfo, setChatInfo] = useState(defaultChatState);
  const [brandInfo, setBrandInfo] = useState({});

  const setOtherUserId = (userId) => {
    const updateChatInfo = { ...chatInfo };
    updateChatInfo.otherUserId = userId;
    setChatInfo(updateChatInfo);
  };

  const { isLoggedIn } = useAuthState();
  const { data, loading: queryLoading } = useQuery(GetSendbirdInfo);

  useEffect(() => {
    if (isLoggedIn && !queryLoading) {
      if (data && data.accounts) {
        const sendbirdInfo = data.accounts[0];
        setChatInfo({ userId: sendbirdInfo.id, otherUserId: undefined });
        setBrandInfo({
          userId: sendbirdInfo.id,
          sendbirdToken: sendbirdInfo.sendbirdToken
        });
      }
    }
  }, [data, isLoggedIn]);

  return (
    <SendBirdProvider
      appId={process.env.REACT_APP_SENDBIRD_TOKEN}
      accessToken={brandInfo.sendbirdToken}
      userId={brandInfo.userId}
    >
      <ChatContext.Provider value={{ chatInfo, setOtherUserId }}>
        {children}
      </ChatContext.Provider>
    </SendBirdProvider>
  );
}
